import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { AtlasMark } from "@/components/brand/AtlasMark";

// The IEBridge wordmark lockup: the concentric-ring brand mark followed by the
// "IEBridge" serif wordmark. Everything is sized in `em` and drawn in
// currentColor, so a caller sets a single font-size + text color on this
// element and both the mark and the word scale together. Reuses `AtlasMark`
// for the rings and the global `.marketing-wordmark` serif treatment for the
// word, keeping a single source of truth for the brand.
export function IEBridgeWordmark(t0) {
  const $ = _c(10);
  let className;
  let markClassName;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      markClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = markClassName;
    $[3] = props;
  } else {
    className = $[1];
    markClassName = $[2];
    props = $[3];
  }
  const t1 = `marketing-wordmark inline-flex items-center gap-[0.34em] leading-none ${className ?? ""}`;
  const t2 = `size-[0.86em] shrink-0 ${markClassName ?? ""}`;
  let t3;
  if ($[4] !== t2) {
    t3 = <AtlasMark className={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t3) {
    t4 = <span className={t1} {...props}>{t3}IEBridge</span>;
    $[6] = props;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}